import { render, staticRenderFns } from "./Membershipapplicationform.vue?vue&type=template&id=c70a65e4&scoped=true"
import script from "./Membershipapplicationform.vue?vue&type=script&lang=js"
export * from "./Membershipapplicationform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a65e4",
  null
  
)

export default component.exports